{
  "datasets": {
    "title": "Datensets",
    "table": {
      "labels": {
        "id": "ID",
        "name": "Name",
        "description": "Beschreibung",
        "raw_size": "Rohe Größe",
        "identifier": "Identifizierer",
        "category": "Kategorie",
        "categoryId": "Kategorie ID",
        "schema": "Schema",
        "database": "Datenbank",
        "import_size": "Import Größe",
        "final_size": "Finale Größe",
        "created_at": "Erstellt am",
        "updated_at": "Aktualisiert am",
        "visible": "Sichtbar",
        "exists": "Existiert",
        "edit": "Editieren",
        "delete": "Löschen",
        "verify_all": "Datensets verifizieren",
        "verify": "Verifizieren",
        "add": "Datenset erstellen",
        "yes": "Ja",
        "no": "Nein",
        "invisible": "Nicht sichtbar",
        "not_exist": "Existiern nicht",
        "not_deletable": "Das Datenset wird bereits benutzt und kann nicht gelöscht werden",
        "imports": "Importe"
      },
      "show_more": "Mehr anzeigen"
    },
    "form": {
      "edit_title": "Datenset editieren",
      "add_title": "Datenset erstellen",
      "add": "Erstellen",
      "save": "Speichern",
      "name": "Name",
      "description": "Beschreibung",
      "database": "Datenbank",
      "schema": "Schema",
      "rawSizeMb": "Rohe Größe (MB)",
      "finalSizeMb": "Finale Größe (MB)",
      "importSizeMb": "Import Größe (MB)",
      "categoryId": "Kategorie",
      "visible": "Sichtbar",
      "identifier": "Identifizierer",
      "errors": {
        "identifier": {
          "duplicate_identifier": "Dieser Identifizierer ist bereits vergeben",
          "no_spaces": "Der Identifizierer darf keine Leerzeichen enthalten",
          "required": "Geben Sie einen Identifizierer an"
        },
        "database": {
          "required": "Geben Sie eine Datenbank an"
        },
        "schema": {
          "required": "Geben Sie ein Schema an"
        },
        "name": {
          "required": "Geben Sie einen Name an"
        },
        "rawSizeMb": {
          "required": "Geben Sie eine Raw Größe an",
          "number": "Raw Größe muss eine Zahl sein"
        },
        "finalSizeMb": {
          "required": "Geben Sie einen Final Größe an",
          "number": "Final Größe muss eine Zahl sein"
        },
        "importSizeMb": {
          "required": "Geben Sie einen Import Größe an",
          "number": "Import Größe muss eine Zahl sein"
        },
        "categoryId": {
          "required": "Wählen Sie eine Kategorie aus"
        },
        "description": {
          "required": "Geben Sie einen Beschreibung an"
        }
      }
    },
    "confirmations": {
      "delete_dataset": "Sind Sie sicher, dass Sie das Datenset {{name}} löschen möchten?"
    },
    "categories": {
      "title": "Datenset Kategorien",
      "table": {
        "labels": {
          "thumbnail": "Thumbnail",
          "name": "Name ({{currentLanguage}})",
          "created_at": "Erstellt am",
          "updated_at": "Aktualisiert am",
          "edit": "Editieren",
          "delete": "Löschen",
          "delete_disabled": "Diese Kategorie wird {{count}} Mal benutzt und kann nicht gelöscht werden",
          "identifier": "Identifizierer",
          "add_category": "Kategorie erstellen",
          "datasets": "Datensets"
        },
        "show_more": "Mehr anzeigen"
      },
      "form": {
        "add_title": "Kategorie erstellen",
        "edit_title": "Kategorie editieren",
        "add": "Erstellen",
        "save": "Speichern",
        "name": "Name ({{currentLanguage}})",
        "identifier": "Identifizierer",
        "upload_thumbnail": "Thumbnail hochladen",
        "warnings": {
          "identifier": "Das Ändern vom \"Identifizierer\" könnte Programme, die auf diesen Wert vertrauen, defekt machen."
        },
        "errors": {
          "name": {
            "required": "Geben Sie einen Namen ({{i18n}}) an"
          },
          "thumbnail": {
            "required": "Geben Sie einen Thumbnail an"
          },
          "identifier": {
            "no_spaces": "Der Identifizierer darf keine Leerzeichen enthalten",
            "duplicate_identifier": "Eine Kategorie mit diesem Identifizierer existiert bereits",
            "required": "Geben Sie einen Identifizierer an"
          }
        }
      },
      "confirmations": {
        "delete_category": "Sind Sie sicher, dass Sie die Kategorie {{name}} löschen möchten?"
      }
    }
  },
  "navigation": {
    "users": "Benutzer",
    "enquiries": "Tickets",
    "datasets": "Datasets",
    "datasets_categories": "Categories",
    "system-config": "Einstellungen",
    "general": "Allgemein",
    "email": "E-Mail",
    "support_configuration": "Support",
    "imprint": "Impressum",
    "send-email": "E-Mail Test",
    "organizations": "Organisationen",
    "orphans": "Verwaiste Cluster",
    "manage_plans": "Pläne",
    "compute_plans": "Leistungspläne",
    "storage_plans": "Speicherpläne",
    "support_plans": "Unterstützungspläne",
    "help": "Hilfe",
    "help_subjects": "Themen",
    "help_articles": "Artikel"
  },
  "clusters": {
    "orphans_title": "Verwaiste Cluster",
    "table": {
      "labels": {
        "namespace": "namespace",
        "status": "status",
        "whitelisted": "whitelisted"
      },
      "actions": {
        "add_to_whitelist": "Zur Whitelist hinzufügen",
        "remove_from_whitelist": "Von Whitelist entfernen",
        "delete_cluster": "Cluster löcschen"
      }
    },
    "modals": {
      "confirm_deleting": "Sind Sie sicher, dass Sie den Cluster löschen möchten? Dies kann nicht rückgängig gemacht werden.",
      "confirm_adding_to_whitelist": "Sind Sie sicher, dass Sie den Cluster zur Whitelist hinzufügen möchten?",
      "confirm_removing_from_whitelist": "Sind Sie sicher, dass Sie den Cluster von der Whitelist entfernen möchten?",
      "success_deleting": "Cluster wurde gelöscht",
      "success_adding": "Cluster wurde zur Whitelist hinzugefügt",
      "success_removing": "Cluster wurde von der Whitelist entfernt"
    }
  },
  "system_configuration": {
    "title": "Allgemeine Einstellungen",
    "form": {
      "allow_service_creation": "Erstellung von Diensten erlauben",
      "show_cost": "Kosten anzeigen",
      "show_instance_cost": "Instanzkosten",
      "show_support_cost": "Supportkosten",
      "min_cpu_value": "Min. Anzahl von CPUs für Cluster",
      "max_cpu_value": "Max. Anzahl von CPUs für Cluster",
      "min_memory_value": "Min. Gbs Speicher für Cluster",
      "max_memory_value": "Max. Gbs Speicher für Cluster",
      "min_storage_value": "Min. Gbs Speicherplatz für Cluster",
      "max_storage_value": "Max. Gbs Speicherplatz für Cluster",
      "min_replicas_value": "Min. Replikate",
      "max_replicas_value": "Max. Replikate",
      "currency": "Währungscode",
      "cpu_price_per_month": "Preis per CPU Einheit per Monat (720h)",
      "memory_price_per_month": "Preis per Arbeitsspeicher GB per Monat (720h)",
      "storage_price_per_month": "Preis per Speicher GB per Monat (720h)",
      "cpu_request_to_limit_multiplier": "Multiplier for CPU Limit in relation to CPU Request (increase to allow \"bursting\")",
      "placeholder": "Leer lassen für unbegrenzt",
      "currency_tooltip": "Der dreistellige Währungscode (z. B. USD, EUR), der zur Anzeige von Preisen verwendet wird. Dies ändert nur das Symbol und hat keinen Einfluss auf Wechselkurse oder tatsächliche Preise",
      "instance_cost_tooltip": "Zeigt die Ressourcenkosten des Dienstes an (CPU, Arbeitsspeicher, Massenspeicher)",
      "support_cost_tooltip": "Zeigt die Kosten für den gewählten Supportplan des Dienstes an "
    },
    "change_saved": "Änderungen gespeichert",
    "change_saved_redirect": "Änderungen gespeichert. Sie können die neue SMTP Konfiguration in <0>E-Mail Test Seite</0> ausprobieren.",
    "redirect_page": "Zu E-Mail Test weiterleiten"
  },
  "email_configuration": {
    "title": "E-Mail Einstellungen",
    "group_titles": {
      "system_notifications": "System Benachrichtigungen"
    },
    "password": {
      "show": "Passwort anzeigen",
      "hide": "Passwort verbergen"
    },
    "token": {
      "show": "Token anzeigen",
      "hide": "Token verbergen",
      "tooltip": "Verwenden Sie einen in „App-Passwörter“ generierten Token aus Ihrem Google-Konto"
    },
    "form": {
      "hostname": "Hostname",
      "port": "Port",
      "username": "Nutzername",
      "password": "Passwort",
      "secure": "Sicher",
      "type": "Typ",
      "enquiryEmails": "Anfrage E-Mail",
      "email_hint": "Empfänger - mehrere Adressen mit Komma trennen (z.B.: email@gmail.com,email@gmail.com)",
      "notification_language": "Sprache der Benachrichtigungen",
      "sender_email": "Absender Adresse",
      "sender_email_hint": "(leer lassen um SMTP Nutzername zu verwenden)",
      "email_address": "E-Mail Adresse",
      "email_token": "E-Mail Token"
    }
  },
  "imprint_configuration": {
    "title": "Impressum Einstellungen",
    "form": {
      "imprint": "Impressum",
      "imprint_tooltip": "Verwenden Sie gültigen HTML-Code"
    }
  },
  "email_test": {
    "title": "E-Mail Test",
    "email": "E-Mail",
    "subject": "Gegenstand",
    "html": "Html",
    "success-modal": "Ihre E-Mail wurde versandt"
  },
  "buttons": {
    "submit": "Absenden"
  },
  "users": {
    "title": "Benutzer",
    "table": {
      "labels": {
        "name": "Name",
        "email": "E-Mail",
        "superuser": "Superuser",
        "activated": "Aktiviert",
        "verified": "Verifiziert",
        "show_more": "Mehr anzeigen"
      },
      "actions": {
        "forgot_passwd": "Passwort vergessen",
        "deactivate": "Deaktivieren",
        "reactivate": "Reaktivieren",
        "add_superuser_rights": "Add superuser privileges",
        "remove_superuser_rights": "Remove superuser privileges"
      },
      "hints": {
        "you": "Sie",
        "forbidden_deactivate_yourself": "Sie können sich nicht selber deaktivieren"
      }
    },
    "description_panel": {
      "labels": {
        "country": "Land",
        "city": "Ort",
        "state": "Bundesland",
        "address": "Adresse",
        "postal_code": "PLZ",
        "phone": "Telefon",
        "email": "E-Mail"
      },
      "yes": "Ja",
      "no": "Nein"
    },
    "confirmations": {
      "deactivate": "Wenn Sie einen Nutzer deaktivieren wird dieser ausgeloggt und kann sich nicht mehr einloggen. Sind Sie sicher, dass Sie den Nutzer {{user}} deaktivieren möchten?",
      "reactivate": "Sich Sie sicher, dass Sie den Nutzer {{user}} reaktivieren möchten?",
      "deactivate_superuser": "Are you sure that you want to remove a superuser privileges for {{user}}?",
      "reactivate_superuser": "Are you sure you want to add a superuser privileges for {{user}}?",
      "forgot_passwd": "Sind Sie sicher, dass Sie den 'Passwort vergessen' Prozess für den Nutzer {{email}} ({{userName}}) starten möchten?"
    },
    "errors": {
      "forgot_passwd": {
        "unprocessable_entity": "Diese E-Mail Adresse existiert nicht"
      },
      "user": {
        "no_superusers_left": "You cannot deactivate your account since you are the last user with active one."
      },
      "superuser_rights": {
        "no_superusers_left": "Sie können Ihre Superuser Privilegien nicht entfernen da Sie der letzte Superuser sind."
      }
    },
    "success": {
      "forgot_passwd": "Der Nutzer {{email}} ({{userName}}) sollte eine E-Mail für das weitere Vorgehen zum Passwort zurücksetzen erhalten haben"
    }
  },
  "manage_plans": {
    "dialogs": {
      "titles": {
        "storage_plan": {
          "create": "Speicherplan erstellen",
          "update": "Speicherplan editieren"
        },
        "compute_plan": {
          "create": "Leistungsplan erstellen",
          "update": "Leistungsplan editieren"
        }
      },
      "actions": {
        "add": "Plan erstellen",
        "edit": "Plan editieren",
        "delete": "Plan löschen"
      },
      "confirmation": {
        "delete_plan": "Sind Sie sicher, dass Sie den Plan \"{{planName}}\" löschen möchten?"
      },
      "labels": {
        "id": "ID",
        "name": "Name",
        "price": "Preis",
        "size": "Speicher [GB]",
        "service": "Service",
        "storage_class": "Speicherklasse",
        "is_visible": "Sichtbar",
        "is_default": "Standard",
        "cpu": "Kerne",
        "memory": "RAM [GB]",
        "replica_min": "Min Replikate",
        "replica_max": "Max Replikate",
        "replica_default": "Std Replikate"
      },
      "errors": {
        "product_already_has_default_plan": "Dieses Produkt hat bereits ein Standard-Plan",
        "replica_default_outside_of_boundaries": "Standard Replikate ist nicht zwischen den min und max Werten",
        "support_plan_duplicate_name": "Ein Supportplan mit diesem Namen existiert bereits"
      },
      "buttons": {
        "submit": "Speichern",
        "cancel": "Abbrechen"
      }
    },
    "storage_plans": {
      "title": "Speicherpläne"
    },
    "compute_plans": {
      "title": "Leistungspläne"
    },
    "support_plans": {
      "title": "Unterstützungspläne"
    },
    "disabled_reasons": {
      "plan_already_in_use": "Löschen nicht möglich da der Plan bereits verwendet wird"
    }
  },
  "material_table": {
    "body": {
      "emptyDataSourceMessage": "Es wurden keine Daten gefunden",
      "addTooltip": "Erstellen",
      "deleteTooltip": "Löschen",
      "editTooltip": "Editieren",
      "filterRow": {
        "filterTooltip": "Filter"
      },
      "editRow": {
        "deleteText": "Möchten Sie diese Zeile wirklich entfernen?",
        "cancelTooltip": "Abbrechen",
        "saveTooltip": "Speichern"
      }
    },
    "grouping": {
      "placeholder": "Spalten umordnen ...",
      "groupedBy": "Gruppiert nach:"
    },
    "header": {
      "actions": "Aktionen"
    },
    "pagination": {
      "labelDisplayedRows": "{from}-{to} von {count}",
      "labelRowsSelect": "Zeilen",
      "labelRowsPerPage": "Zeilen pro Seite:",
      "firstAriaLabel": "Erste Seite",
      "firstTooltip": "Erste Seite",
      "previousAriaLabel": "Vorherige Seite",
      "previousTooltip": "Vorherige Seite",
      "nextAriaLabel": "Nächste Seite",
      "nextTooltip": "Nächste Seite",
      "lastAriaLabel": "Letzte Seite",
      "lastTooltip": "Letzte Seite"
    },
    "toolbar": {
      "addRemoveColumns": "Spalte erstellen oder löschen",
      "nRowsSelected": "{0} Zeile(n) selektiert",
      "showColumnsTitle": "Spalten anzeigen",
      "showColumnsAriaLabel": "Spalten anzeigen",
      "exportTitle": "Exportieren",
      "exportAriaLabel": "Exportieren",
      "exportName": "Als CSV exportieren",
      "searchTooltip": "Suchen",
      "searchPlaceholder": "Suchen"
    }
  },
  "organizations": {
    "title": "Organisationen",
    "table": {
      "label": {
        "name": "Name",
        "description": "Beschreibung",
        "email": "Email",
        "verified": "Verifiziert",
        "show_more": "Mehr...",
        "info": "Info",
        "company_name": "Unternehmensname",
        "language": "Sprache"
      }
    },
    "description_panel": {
      "details": {
        "name": "Name",
        "company_name": "Unternehmensname",
        "description": "Beschreibung",
        "email": "E-Mail",
        "vat_number": "UID",
        "verified": "Verifiziert",
        "language": "Sprache"
      },
      "address": {
        "line1": "Zeile 1",
        "line2": "Zeile 2",
        "line3": "Zeile 3",
        "postal_code": "PLZ",
        "city": "Ort",
        "state": "Bundesland",
        "country": {
          "code": "Code",
          "name": "Name",
          "calling_code": "Int. Vorwahl"
        }
      },
      "yes": "Ja",
      "no": "Nein"
    },
    "info_list": {
      "fields": {
        "projects": "Projekte",
        "users": "Benutzer",
        "teams": "Teams",
        "invitations": "Einladungen",
        "registration_invitations": "Registrierungseinladungen"
      },
      "user": {
        "first_name": "Vorname",
        "middle_name": "Mittlerer Name",
        "last_name": "Nachname",
        "email_address": "E-Mail",
        "role": "Rolle",
        "verified": "Verifiziert",
        "marketable": "Empfängt Marketing",
        "phone_number": "Telefon"
      }
    },
    "empty_section": "Dieser Abschnitt ist leer"
  },
  "postgres_version": {
    "label": "PostgreSQL-Version",
    "postgresql": "PostgreSQL"
  },
  "help": {
    "subjects": {
      "table": {
        "title": "Subjects",
        "labels": {
          "subject_title": "Title",
          "updated_at": "Updated at",
          "articles": "Articles",
          "show_more": "Mehr anzeigen"
        },
        "actions": {
          "edit": "Edit subject",
          "delete": "Delete subject",
          "add": "Create subject"
        },
        "disabled_reasons": {
          "subject_has_articles": "Can't delete because subject has articles"
        },
        "confirmation": {
          "delete_subject": "Are you sure you want to delete \"{{subject}}\" subject?"
        }
      },
      "details_panel": {
        "title": "Title ({{lang}})",
        "created_at": "Created At",
        "updated_at": "Updated At",
        "articles": "Articles"
      },
      "subject_form": {
        "edit_title": "Edit Subject",
        "create_title": "Create Subject",
        "submit": "Submit",
        "cancel": "Cancel",
        "form": {
          "name": "Title ({{lang}})"
        }
      }
    },
    "articles": {
      "table": {
        "title": "Articles",
        "labels": {
          "subjects": "Subjects",
          "article_title": "Title",
          "short_content": "Short content",
          "updated_at": "Updated at",
          "show_more": "Mehr anzeigen"
        },
        "actions": {
          "edit": "Edit article",
          "delete": "Delete article",
          "add": "Create article"
        },
        "confirmation": {
          "delete_article": "Are you sure you want to delete \"{{article}}\" article?"
        }
      },
      "details_panel": {
        "title": "Title ({{lang}})",
        "short_content": "Short Content ({{lang}})",
        "content": "Content ({{lang}})",
        "created_at": "Created At",
        "updated_at": "Updated At",
        "subjects": "Subjects"
      },
      "article_form": {
        "edit_title": "Edit Article",
        "create_title": "Create Article",
        "editor_title": "Text Editor",
        "submit": "Submit",
        "cancel": "Cancel",
        "save": "Save",
        "form": {
          "subjects": "Subjects",
          "title": "Title ({{lang}})",
          "short_content": "Short content ({{lang}})",
          "content": "Content ({{lang}})",
          "errors": {
            "subject": {
              "required": "Subjects field is required"
            }
          }
        }
      }
    }
  }
}
